var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VApp',{attrs:{"id":"onboarding-app"}},[_c('VContainer',{attrs:{"fill-height":"","fluid":""}},[_c('VRow',{attrs:{"justify":"center"}},[_c('VCol',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }